export default {
  'OUTBOUND-CLICK-BTN-TASKASSIGN-SEARCH-BTN': {
    key: 'outbound-click-btn-taskAssign-search-btn',
    label: '任务分配-列表-点击搜索'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-FIRSTENTER': {
    key: 'outbound-click-btn-taskAssign-firstEnter',
    label: '点击-任务分配-首次进入'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-TASKDETAIL': {
    key: 'outbound-click-btn-taskAssign-taskDetail',
    label: '点击-任务分配-任务明细'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-HUMAN-ASSIGN': {
    key: 'outbound-click-btn-taskAssign-human-assign',
    label: '点击-任务分配-手动组单'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CHOOSEORDER': {
    key: 'outbound-click-btn-taskAssign-chooseOrder',
    label: '点击-任务分配-选择订单'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-SEARCH': {
    key: 'outbound-click-btn-taskAssign-custom-search',
    label: '点击-任务分配-自定义筛选'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-SEARCH-ADD': {
    key: 'outbound-click-btn-taskAssign-custom-search-add',
    label: '点击-任务分配-自定义筛选-增加'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-SEARCH-DEL': {
    key: 'outbound-click-btn-taskAssign-custom-search-del',
    label: '点击-任务分配-自定义筛选-减少'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-HEADER': {
    key: 'outbound-click-btn-taskAssign-custom-header',
    label: '点击-任务分配-自定义表头'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-HEADER-ADD': {
    key: 'outbound-click-btn-taskAssign-custom-header-add',
    label: '点击-任务分配-自定义表头-增加'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-CUSTOM-HEADER-DEL': {
    key: 'outbound-click-btn-taskAssign-custom-header-del',
    label: '点击-任务分配-自定义表头-减少'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-SEARCH-BTN': {
    key: 'outbound-click-btn-taskAssign-new-search-btn',
    label: '任务分配-列表-点击搜索'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-FIRSTENTER': {
    key: 'outbound-click-btn-taskAssign-new-firstEnter',
    label: '点击-任务分配-首次进入'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-TASKDETAIL': {
    key: 'outbound-click-btn-taskAssign-new-taskDetail',
    label: '点击-任务分配-任务明细'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-HUMAN-ASSIGN': {
    key: 'outbound-click-btn-taskAssign-new-human-assign',
    label: '点击-任务分配-手动组单'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CHOOSEORDER': {
    key: 'outbound-click-btn-taskAssign-new-chooseOrder',
    label: '点击-任务分配-选择订单'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-SEARCH': {
    key: 'outbound-click-btn-taskAssign-new-custom-search',
    label: '点击-任务分配-自定义筛选'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-SEARCH-ADD': {
    key: 'outbound-click-btn-taskAssign-new-custom-search-add',
    label: '点击-任务分配-自定义筛选-增加'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-SEARCH-DEL': {
    key: 'outbound-click-btn-taskAssign-new-custom-search-del',
    label: '点击-任务分配-自定义筛选-减少'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-HEADER': {
    key: 'outbound-click-btn-taskAssign-new-custom-header',
    label: '点击-任务分配-自定义表头'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-HEADER-ADD': {
    key: 'outbound-click-btn-taskAssign-new-custom-header-add',
    label: '点击-任务分配-自定义表头-增加'
  },
  'OUTBOUND-CLICK-BTN-TASKASSIGN-NEW-CUSTOM-HEADER-DEL': {
    key: 'outbound-click-btn-taskAssign-new-custom-header-del',
    label: '点击-任务分配-自定义表头-减少'
  }
}
